import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import CurrencyConversion from './currencyConversion'

class SendCurrencyConversion extends React.Component {
  static propTypes = {
    selectedFundingOption: PropTypes.object.isRequired,
    currencyDecimal: PropTypes.string.isRequired,
    userCountry: PropTypes.string.isRequired,
    shouldShowCurrencyConversionLink: PropTypes.bool.isRequired,
    isPurchase: PropTypes.bool.isRequired,
    xbRate: PropTypes.string,
    isReview: PropTypes.bool,
    language: PropTypes.string,
    isFeeDisclaimerMessageDisabled: PropTypes.bool,
  }

  render() {
    return (
      <CurrencyConversion
        selectedFundingOption={this.props.selectedFundingOption}
        currencyDecimal={this.props.currencyDecimal}
        userCountry={this.props.userCountry}
        language={this.props.language}
        shouldShowCurrencyConversionLink={
          this.props.shouldShowCurrencyConversionLink
        }
        isPurchase={this.props.isPurchase}
        xbRate={this.props.xbRate}
        isReview={this.props.isReview}
        isFeeDisclaimerMessageDisabled={
          this.props.isFeeDisclaimerMessageDisabled
        }
      />
    )
  }
}

export default connect(({ amount, transaction, user, crossBorder }) => ({
  selectedFundingOption: transaction.selectedFundingOption,
  isPurchase: transaction.isPurchase,
  currencyDecimal: amount.currencyDecimal,
  userCountry: user.country,
  language: user.language,
  xbRate: crossBorder.rate,
}))(SendCurrencyConversion)
